<script lang="ts">

  import { current } from "$lib/global-date"
  import { onMount } from "svelte"

  const pattern = "EEEE, dd/MM/yyyy HH:mm:ss"

  let time = $state("-")

  onMount(() => {
    time = current().format(pattern)

    const timer = setInterval(() => {
      time = current().format(pattern)
    }, 1000)

    return () => clearInterval(timer)
  })

</script>

<div
  class="col-span-5 flex items-center justify-center rounded-md border px-3 py-1 text-sm font-light tabular-nums tracking-wide">
  {time}
</div>
